import React from 'react'
import { Box, Divider } from '@mui/material'
import ProfileSelector from './ProfileSelector'
import ResumeSelector from './ResumeSelector'

const Sidebar = ({ onProfileEditorSelect, onResumeEditorSelect }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <ProfileSelector onProfileEditorSelect={onProfileEditorSelect} />
      <Divider sx={{ mt: 2.5, mb: 2.5 }} />
      <ResumeSelector onResumeEditorSelect={onResumeEditorSelect} />
      {/* Future components will be added here, separated by Divider components */}
    </Box>
  )
}

export default Sidebar
